import React, { useState } from 'react';
import Button from '@mui/material/Button';
import EmailCard from './EmailCard'; // Ensure the path to EmailCard is correct
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';

/**
 * BntDownloadDocumentation Component
 * 
 * A button that triggers the display of an EmailCard component when clicked. 
 * This button has responsive styling and uses Material-UI's Button component.
 * 
 * @param {Object} props - The component props
 * @param {Array} props.selectedModules - List of selected modules to include in the email
 * @param {number} props.price - Price information to include in the email
 * @param {string} props.deliveryTime - Delivery time information to include in the email
 * @returns {JSX.Element} - The rendered button component
 */
const BntDownloadDocumentation = ({ selectedModules, price, deliveryTime }) => {
  const [showEmailCard, setShowEmailCard] = useState(false); // State to control the visibility of the card

  /**
   * Handles button click to show the email card.
   */
  const handleDownloadClick = () => {
    setShowEmailCard(true); // Shows the card when the button is clicked
  };

  return (
    <div>
      <Button
        sx={{
          left: '10%', // Positions the button 10% from the left edge of its container
          marginTop: '5%', // Adds a top margin of 5% for spacing
          width: '80%', // Sets the button width to 80% of its container
          height: '5%', // Sets the button height to 5% of its container
          backgroundColor: '#fff', // Sets the background color of the button to white
          border: '1px solid #1976d2', // Adds a 1px solid border with a blue color
          color: '#1976d2', // Sets the text color to blue
          textTransform: 'none', // Disables text transformation (e.g., no uppercase)
          fontSize: '16px', // Sets the font size to 16px
          fontWeight: 500, // Sets the font weight to 500
          display: 'flex', // Uses flexbox for layout
          alignItems: 'center', // Vertically centers items within the button
          justifyContent: 'center', // Horizontally centers items within the button
          boxShadow: 'none', // Removes the default box shadow
          '&:hover': {
            backgroundColor: '#e3f2fd', // Changes the background color on hover
            borderColor: '#1976d2', // Changes the border color on hover
          },
          '@media (max-width: 1200px)': {
            display: 'flex', // Ensures the button remains a flex container
            marginLeft: '-6%', // Adjusts left margin for smaller screens
            justifyContent: 'flex-start', // Aligns content to the left
            width: '98%', // Expands button width to 98% of its container
            height: 'auto', // Sets the height to auto for better flexibility
            fontSize: '14px', // Reduces font size for smaller screens
            marginTop: '0%', // Removes top margin for better spacing on smaller screens
          },
          '@media (max-width: 768px)': {
            display: 'flex', // Ensures the button remains a flex container
            marginLeft: '-6%', // Adjusts left margin for very small screens
            justifyContent: 'flex-start', // Aligns content to the left
            width: '98%', // Expands button width to 98% of its container
            fontSize: '12px', // Further reduces font size for very small screens
            marginTop: '3%', // Adds top margin for better spacing on very small screens
          },
        }}
        startIcon={<VerticalAlignBottomIcon />} // Adds a download icon to the button
        onClick={handleDownloadClick} // Shows the card when the button is clicked
      >
        Download Documentation
      </Button>

      {/* Conditionally renders the EmailCard with selected modules */}
      {showEmailCard && <EmailCard selectedModules={selectedModules} deliveryTime={deliveryTime} price={price} setShowEmailCard={setShowEmailCard} />}
    </div>
  );
};

export default BntDownloadDocumentation;
